import { render } from "./Learning.vue?vue&type=template&id=4148fe64&scoped=true"
import script from "./Learning.vue?vue&type=script&lang=js"
export * from "./Learning.vue?vue&type=script&lang=js"

import "./Learning.vue?vue&type=style&index=0&id=4148fe64&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4148fe64"]])

export default __exports__